// WordmarkRegistration.jsx
import React from "react";

export default function WordmarkRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Wordmark Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Wordmark Registration for Brand Protection
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in securing Wordmark
            Registration for brand protection, helping you protect your brand
            name as a registered trademark in relevant classes of goods or
            services.
          </p>
          <p className="text-gray-700">
            From assessing the distinctiveness of your mark and guiding you on
            class selection to preparing application details, the process is
            managed in an organized way so that your brand name can be filed and
            tracked with clarity.
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Brand and trademark team planning wordmark registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Wordmark Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps applicants collate the basic
              information and documents required to file a wordmark application
              for trademark registration.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Brand name / wordmark details, including spelling, format, and
                  list of goods or services (classes) for which protection is
                  sought.
                </li>
                <li>
                  Applicant identity and address proof (PAN, Aadhaar, passport,
                  voter ID, or driving licence, depending on the applicant
                  type).
                </li>
                <li>
                  Basic details of the applicant (individual / firm / company /
                  LLP), including name, address, and contact information.
                </li>
                <li>
                  Logo file, if the wordmark is to be used along with a specific
                  stylized logo or device (optional where only the word is to be
                  protected).
                </li>
                <li>
                  Information on date of first use of the mark in India, if
                  already in use, along with any supporting proof where
                  available.
                </li>
                <li>
                  Authorization in favour of the filing professional, if the
                  application is being filed through an agent or attorney.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers focused support for brand protection, combining
              practical trademark know‑how with clear, process‑driven filing and
              follow‑up.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trademark Law Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on distinctiveness, class selection, and filing
                  strategy so that the wordmark application is aligned with
                  trademark law requirements.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Filing Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in preparing application details and descriptions
                  correctly, helping reduce the risk of objections or technical
                  issues.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Brand Protection Services
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing assistance from filing and examination stages through
                  publication and registration, offering continued support for
                  your brand protection journey.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
